import {Button} from "primereact/button";
import React, {useEffect, useState} from "react";
import {Dialog} from "primereact/dialog";
import {InputText} from "primereact/inputtext";
import {Dropdown} from "primereact/dropdown";
import {InputTextarea} from "primereact/inputtextarea";
import {Calendar} from "primereact/calendar";
import { ProgressSpinner } from 'primereact/progressspinner';
import {endpoints} from "../constants/env/middletier";
import ClientsDropdown from "./ClientsDropdown";


export default function AddProjectForm({ addProjectFormVisible, setAddProjectFormVisible }) {
    const [loading, setLoading] = useState(false);
    const [selectedClient, setSelectedClient] = useState(null);

    const handleNewProjectSubmit = async (e) => {
        console.log('Form values:', project);
        e.preventDefault();
        setLoading(true);

        try {
            const response = await fetch(Endpoints["project"], {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(project),
            });

            const result = await response.json();
            console.log("Success:", result);

            clearFormValues();
        } catch (error) {
            console.error("Error submitting form:", error);
        } finally {
            setLoading(false);
        }
    };

    const clearFormValues = (e) => {
        setProject({
            name: '',
            number: '',
            clientId: '',
            clientName: '',
            clientAbbreviation: '',
            status: '',
            cxType: '',
            cxTasks: '',
            grossSquareFootage: '',
            timezone: '',
            startDate: null,
            anticipatedCompletionDate: null,
            notes: ''
        });
    }

    const [project, setProject] = useState({
        name: 'Cx Building Project 1',
        number: '54015.1',
        clientId: 1,
        clientName: 'ACME industries building division',
        clientAbbreviation: 'ref1',
        status: 'In Progress',
        cxType: 'New Building Commission',
        cxTasks: 'task1',
        grossSquareFootage: '10000',
        timezone: 'eastern',
        startDate: new Date('2015-08-15'),
        anticipatedCompletionDate: new Date('2025-08-15'),
        notes: 'This project is for testing purposes only'
    });

    const statusOptions = [
        { label: 'In Progress', value: 'In Progress' },
        { label: 'Pending', value: 'Pending' },
        { label: 'Completed', value: 'Completed' }
    ];

    const cxTypeOptions = [
        { label: 'New Building Commission', value: 'New Building Commission' },
        { label: 'Retro Commission', value: 'Retro Commission' },
        { label: 'Recommissioning', value: 'Recommissioning' }
    ];

    const timezoneOptions = [
        { label: 'Eastern', value: 'eastern' },
        { label: 'Central', value: 'central' },
        { label: 'Mountain', value: 'mountain' },
        { label: 'Pacific', value: 'pacific' }
    ];

    const updateField = (field, value) => {
        setProject((prev) => ({
            ...prev,
            [field]: value
        }));
    };

    const handleClientsDropdownChange = async (data) => {

        updateField('clientId', data)

        console.log("Setting client dropdown");
        console.log(data);
        const value = data;
        console.log(data);
        setSelectedClient(value);
        console.log("value");
        console.log(value);
    };

    return (
    <>
        <div className="card">
            <Dialog header="Add Project" visible={addProjectFormVisible} style={{ width: '90vw' }}
                    breakpoints={{
                        '960px': '95vw',
                        '640px': '100vw'
                    }}
                    maximizable
                    modal onHide={() => setAddProjectFormVisible(false)}>


                <div className="grid formgrid p-fluid">

                    <div className="field col-12 md:col-6">
                        <label htmlFor="name">Project Name</label>
                        <InputText
                            id="name"
                            value={project.name}
                            onChange={(e) => updateField('name', e.target.value)}
                        />
                    </div>

                    <div className="field col-12 md:col-4">
                        <label htmlFor="number">Project Number</label>
                        <InputText
                            id="number"
                            value={project.number}
                            onChange={(e) => updateField('number', e.target.value)}
                        />
                    </div>

                    <div className="field col-12 md:col-4">
                        <label htmlFor="clientDropdown">Client</label>
                        <ClientsDropdown id="clientDropdown" onGetClients={handleClientsDropdownChange} />
                    </div>

                    <div className="field col-12 md:col-4">
                        <label htmlFor="status">Status</label>
                        <Dropdown
                            id="status"
                            value={project.status}
                            options={statusOptions}
                            onChange={(e) => updateField('status', e.value)}
                            placeholder="Select Status"
                        />
                    </div>

                    <div className="field col-12 md:col-4">
                        <label htmlFor="cxType">Commissioning Type</label>
                        <Dropdown
                            id="cxType"
                            value={project.cxType}
                            options={cxTypeOptions}
                            onChange={(e) => updateField('cxType', e.value)}
                            placeholder="Select Type"
                        />
                    </div>

                    <div className="field col-12 md:col-4">
                        <label htmlFor="cxTasks">Commissioning Tasks</label>
                        <InputText
                            id="cxTasks"
                            value={project.cxTasks}
                            onChange={(e) => updateField('cxTasks', e.target.value)}
                        />
                    </div>
                    <div className="field col-12 md:col-4">
                        <label htmlFor="grossSquareFootage">
                            Gross Square Footage
                        </label>
                        <InputText
                            id="grossSquareFootage"
                            value={project.grossSquareFootage}
                            onChange={(e) =>
                                updateField(
                                    'grossSquareFootage',
                                    e.target.value
                                )
                            }
                        />
                    </div>


                    <div className="field col-12 md:col-4">
                        <label htmlFor="timezone">Timezone</label>
                        <Dropdown
                            id="timezone"
                            value={project.timezone}
                            options={timezoneOptions}
                            onChange={(e) => updateField('timezone', e.value)}
                            placeholder="Select Timezone"
                        />
                    </div>


                    <div className="field col-12 md:col-4">
                        <label htmlFor="startDate">Start Date</label>
                        <Calendar
                            id="startDate"
                            className="custom-calendar"
                            value={project.startDate}
                            onChange={(e) =>
                                updateField('startDate', e.value)
                            }
                            showIcon
                            dateFormat="yy-mm-dd"
                        />
                    </div>

                    <div className="field col-12 md:col-4">
                        <label htmlFor="anticipatedCompletionDate">
                            Anticipated Completion Date
                        </label>
                        <Calendar
                            id="anticipatedCompletionDate"
                            className="custom-calendar"
                            value={project.anticipatedCompletionDate}
                            onChange={(e) =>
                                updateField(
                                    'anticipatedCompletionDate',
                                    e.value
                                )
                            }
                            showIcon
                            dateFormat="yy-mm-dd"
                        />
                    </div>

                    <div className="field col-12">
                        <label htmlFor="notes">Notes</label>
                        <InputTextarea
                            id="notes"
                            rows={5}
                            value={project.notes}
                            onChange={(e) => updateField('notes', e.target.value)}
                        />
                    </div>
                    {loading ? ( <ProgressSpinner /> ) : ( <div></div> )}

                    <div className="field col-12 md:col-10">

                    </div>
                    <div className="field col-12 md:col-2">
                        <Button
                            type="submit"
                            label="Save Project"
                            icon="pi pi-save"
                            severity="info"
                            onClick={handleNewProjectSubmit}
                        />
                    </div>

                </div>
            </Dialog>
        </div>

    </ >
);
}